export const BL10_CONCOX = [
    { label: 'Reconnect', command: 'track', icon: 'Track', isPopUp: false }
];